import { RBACActions, RBACLevels, RBACPermissionTypes } from '@protector/entities/rbac/constants';
import { getLicensingStatus } from 'core/core.selectors';
import { verifyUserAccessInRegionalOverview } from 'core/utils/functions';
import { getLoadingLicensingStatus, hasHideMenuOptionWithoutSeason, hasRTRPlanEntitlement } from 'entities/company/company.selectors';
import { useGetRBACAuthorityUser } from 'querys/rbac/rbac.query';
import { useSelector } from 'react-redux';

export const useHasRiskManagementAccess = (): boolean => {
  const licensingStatus = useSelector(getLicensingStatus);
  const isLoadingLicensingStatus = useSelector(getLoadingLicensingStatus);
  const showOnlyNotesFeature = useSelector(hasRTRPlanEntitlement);
  const hideMenuOptionWithoutSeason = useSelector(hasHideMenuOptionWithoutSeason);

  const regionalRiskPermission = useGetRBACAuthorityUser({
    rbacActions: RBACActions.REGIONAL_RISK,
    rbacLevels: RBACLevels.ORG,
    rbacPermission: [RBACPermissionTypes.NOT_READ]
  });

  return (
    !isLoadingLicensingStatus &&
    !(showOnlyNotesFeature && hideMenuOptionWithoutSeason) &&
    verifyUserAccessInRegionalOverview(licensingStatus) &&
    Array.isArray(regionalRiskPermission) &&
    !regionalRiskPermission.length
  );
};
